'use strict'

import {
  Polymer
} from '@polymer/polymer/lib/legacy/polymer-fn.js'
import {
  dom,
  flush
} from '@polymer/polymer/lib/legacy/polymer.dom.js'
import {
  html
} from '@polymer/polymer/lib/utils/html-tag.js'
import '@polymer/iron-collapse/iron-collapse'
Polymer({
  is: 'moskito-authors',
  _template: html`
<style include="iron-flex iron-flex-alignment">
:host {
  display: inline-block;
}
moskito-author {
  margin: 0 8px 16px 8px;
}
.wrap {
  margin: 0 0 16px 0;
  align-items: flex-start;
  justify-content: space-between;
}
</style>
<div class="horizontal layout wrap">
  <template is="dom-repeat" items="{{authors}}">
    <moskito-author author="[[item]]" class="v-spaced flex"></moskito-author>
  </template>
</div>
`,
  properties: {
    authors: {
      type: Array,
      notify: true
    }
  },
  isTranslation: function (title) {
    if (title.original.language === 'fr') {
      return false
    } else {
      return true
    }
  }
})
